<template>

  <div v-if="type==='default'&& !parent" class="tr">
    <div class="th">{{ element.label }}</div>
    <div class="td">
      <img v-for="(image,index) in data[element.id]" style="width: 100px;height: auto" :key="index"
           :src="appStore.downloadUrl(image.id)"/>
    </div>
  </div>
  <template v-else-if="type==='excel'">
    <div class="th">{{ element.label }}</div>
    <div class="td">
      <img v-for="(image,index) in data[element.id]" style="width: 100px;height: auto" :key="index"
           :src="appStore.downloadUrl(image.id)"/>
    </div>
  </template>
  <span v-else>
    <img v-for="(image,index) in data[element.id]" style="width: 100px;height: auto" :key="index"
                     :src="appStore.downloadUrl(image.id)"/>
  </span>

</template>

<script>

import {mapStores} from "pinia";
import {useAppStore} from "@/stores/app";

export default {
  components: {},
  computed: {
    ...mapStores(useAppStore)
  },
  props: {
    form: {
      type: Object,
    },
    data: {
      type: Object,
    },
    element: {
      type: Object
    },
    parent: {
      type: Object
    },
    type: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {}
  },
  created() {
  }
}

</script>

<style scoped lang="scss">

</style>